import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://xxelsycntuzgbmedbctf.supabase.co"; // kendi Supabase URL
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inh4ZWxzeWNudHV6Z2JtZWRiY3RmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU1NTYxNTgsImV4cCI6MjA3MTEzMjE1OH0.W_NwlhqBHibX_GV8IC1y1Y8kabciWam6vCvFr3m2SDU"; // kendi anon key

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
